/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
// import { get } from 'lodash';
import NumberFormat from '../../utils/NumberFormat';

const borderColor = '#3778C2';
const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    borderBottomColor: '#3778C2',
    borderBottomWidth: 1,
    alignItems: 'center',
    height: 24,
    fontStyle: 'bold',
  },
  description: {
    width: '35%',
    textAlign: 'left',
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingLeft: 8,
  },
  saida: {
    width: '25%',
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: 'left',
    paddingLeft: 8,
  },
  destino: {
    width: '25%',
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: 'left',
    paddingLeft: 8,
  },
  valor: {
    width: '15%',
    textAlign: 'right',
    paddingRight: 8,
  },
});

function InvoiceTableRow({ items }) {
  const rows = items.map((item) => (
    <View style={styles.row} key={item.id.toString()}>
      <Text style={styles.description}>{item.descricao}</Text>
      <Text style={styles.saida}>{item.LocalSaida.municipio}</Text>
      <Text style={styles.destino}>{item.LocalDestino.municipio}</Text>
      <Text style={styles.valor}>{NumberFormat(item.valor)}</Text>
    </View>
  ));
  return <>{rows}</>;
}

export default InvoiceTableRow;
